import { mainAxios } from '@organization/api/axios/mainAxios'
import { OrganizationShort } from '@organization/api/requests'
import { getUrlSubDomain } from '@organization/utils'
import { LoadingScreen } from '@shared/components'
import { useQuery } from '@tanstack/react-query'
import { Alert, Flex, Image, Typography } from 'antd'

import { useTranslation } from 'react-i18next'

import { useStyle } from './styles'

interface Props {
  message: (name?: string) => string
}

const domainName = getUrlSubDomain
const noAuthConfig = { skipAuthHeader: true, headers: {} }

export const OrganizationLogo = ({ message }: Props) => {
  const { styles } = useStyle()
  const { t } = useTranslation()

  const { data, isPending } = useQuery({
    queryKey: [domainName],
    queryFn: () =>
      mainAxios
        .get<OrganizationShort>(
          `/organizations/info/${domainName}/`,
          noAuthConfig
        )
        .then((r) => r.data),
    enabled: !!domainName,
    retry: false
  })

  if (isPending) {
    return <LoadingScreen />
  }

  return data ? (
    <Flex vertical gap={20}>
      <Image
        className={styles.organizationImage}
        width={100}
        height="auto"
        preview={false}
        src={data?.photo || '/images/logo.svg'}
        alt={data?.name}
      />

      <Typography.Title level={4}>{message(data?.name)}</Typography.Title>
    </Flex>
  ) : (
    <Alert type="error" message={t('error.organization_logo')} showIcon />
  )
}
